import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";

import Breadcrumbs from "components/Common/BreadcrumbTitle";

import { editRole, getOneRole } from "../../helpers/UAM/role.helper";
import { SystemConfigurationContext } from "context/systemConfigContext";

const UpdateRole = (props) => {
  document.title = "Update Role | DMS";
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);
  const [roleList, setRoleList] = useState({});
  const {inputMax} = useContext(SystemConfigurationContext)

  useEffect(() => {
    getOneRole({ roleId: decodedId })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setRoleList(responseFromAPI.data);
        }
      })
      .catch(error => { })
  }, []);

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      roleName: (roleList.roleName) || "",
      roleDescription: (roleList.roleDescription) || "",
      displayName: (roleList.displayName) || "",
      entityType: (roleList.entityType) || "",
    },
    validationSchema: Yup.object({
      roleName: Yup.string().required("Please Enter Permission Name"),
      roleDescription: Yup.string().required("Please Enter Role Description"),
      displayName: Yup.string().required("Please Enter Role Display Name"),
      entityType: Yup.string().required("Please Select Entity Type"),
    }),
    onSubmit: (values) => {
      const updateRole = {
        id: decodedId,
        roleName: values.roleName,
        roleDescription: values.roleDescription,
        displayName: values.displayName,
        entityType: values.entityType,
      };

      editRole(updateRole)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            navigate(`/${roleName}/roles`)
          }
        })
        .catch(error => { })
      validation.resetForm();
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="UPDATE ROLE" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Col md="6" sm="12">
                        <Label className="form-label mt-2 required">Role Name</Label>
                        <Input
                          maxLength={inputMax}
                          name="roleName"
                          type="text"
                          placeholder="Enter Role Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.roleName || ""}
                          invalid={
                            validation.touched.roleName &&
                            validation.errors.roleName
                          }
                        />
                        {validation.touched.roleName &&
                          validation.errors.roleName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.roleName}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col md="6" sm="12">
                        <Label className="form-label mt-2 required">
                          Role Description
                        </Label>
                        <Input
                          maxLength={inputMax}
                          name="roleDescription"
                          type="text"
                          placeholder="Enter Role Description"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.roleDescription || ""}
                          invalid={
                            validation.touched.roleDescription &&
                            validation.errors.roleDescription
                          }
                        />
                        {validation.touched.roleDescription &&
                          validation.errors.roleDescription ? (
                          <FormFeedback type="invalid">
                            {validation.errors.roleDescription}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col md="6" sm="12">
                        <Label className="form-label mt-2 required">
                          Role Display Name
                        </Label>
                        <Input
                          maxLength={inputMax}
                          name="displayName"
                          type="text"
                          placeholder="Enter Role Display Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.displayName || ""}
                          invalid={
                            validation.touched.displayName &&
                            validation.errors.displayName
                          }
                        />
                        {validation.touched.displayName &&
                          validation.errors.displayName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.displayName}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col md="6" sm="12">
                        <Label className="form-label mt-2 required">Entity Type</Label>
                        <Input
                          maxLength={inputMax}
                          name="entityType"
                          type="select"
                          placeholder="Select Entity Type"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.entityType || ""} 
                          invalid={
                            validation.touched.entityType &&
                            validation.errors.entityType
                          }
                        >
                          <option value="" disabled>Select Entity Type</option>
                          <option value="anchor">Admin</option>
                          <option value="dealer">Dealer</option>
                        </Input>
                        {validation.touched.entityType &&
                          validation.errors.entityType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.entityType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-4">
                        <div className="text-end">
                          <button
                            className="btn btn-outline-secondary save-customer me-3"
                            onClick={() => navigate(-1)}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UpdateRole;

UpdateRole.propTypes = {
  history: PropTypes.object,
};
